module.exports = __webpack_public_path__ + "static/media/process-flow.2d091a58.png";